<template>
  <div class="carGallery">
    <div class="image-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="image-box"
        :class="{ default: defaultImageIndex === index }"
      >
        <img
          :src="image.url"
          alt="Selected Image"
          @click="setDefaultImage(index)"
        />
        <button type="button" @click="removeImage(index)"></button>
      </div>
      <input
        type="file"
        id="fileInput"
        @change="handleFileUpload"
        :multiple="multiple"
      />
      <label
        for="fileInput"
        v-if="multiple || (!multiple && images.length === 0)"
        class="upload-button"
        >{{ uploadText }}</label
      >
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AddGalleryFiles",
  props: {
    multiple: {
			required: false,
      type: Boolean,
			default: false
    },
    uploadText: {
			required: false,
			type: String,
      default: "+ הוספת תמונה",
    },
		car: {
			required: true
		}
  },
  data() {
    return {
      images: [],
      defaultImageIndex: null,
    };
  },
  methods: {
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
			let loadedFilesCount = 0;
      for (const file of files) {
        const reader = new FileReader();
        reader.onload = () => {
          this.images.push({
            url: reader.result,
						file
          });
					loadedFilesCount++;
					if(loadedFilesCount === files.length){
						this.uploadImages(files);
					}
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage(index) {
      const image = this.images.splice(index, 1);
      if (index === this.defaultImageIndex) {
        this.defaultImageIndex = null;
      }
			if(image && image[0]){
				this.deleteCarImage({id: this.car.id, path: image[0].path})
			}
    },
    setDefaultImage(index) {
      this.defaultImageIndex = index;
			this.$emit('thumbnail-index', index)
    },
		async uploadImages(files){
			for (const file of files) {
				await this.saveCarImage({id: this.car.id || null, image: file})
			}
		},
		...mapActions(['saveCarImage','deleteCarImage'])
  },
	mounted() {
		if(this.car){
			if(this.car.images){
				this.images = JSON.parse(JSON.stringify(this.car.images))
			}

			if(this.car.thumbnail_index){
				this.defaultImageIndex = this.car.thumbnail_index
			}
		}
	}
};
</script>
